import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';

import validate from './validations';

import { Field } from 'redux-form';
import InputGroup from '../InputGroup';
import Button from '../Button';
import TwoGroup from '../TwoGroup';

import GetUpdatesCheckbox from '../Widget/GetUpdatesCheckbox';

import { LoadingSpinner } from '../../components/LoadingSpinner';

import {
    Container,
    ButtonGroupWrapper,
    MultipleGroupHalf
} from '../../containers/DefaultStyles/FormDetails';
import { isPortrait } from '../../utils/size';
import { getCachedFirstName, getCachedLastName } from '../../utils/formCaching/helpers';

const CheckboxWrapper = styled.div`
    ${() =>
        !isPortrait()
            ? `
        position: absolute;
        left: -195px;
        top: 280px;
      `
            : ``};
`;

class ElectionReminderForm extends React.Component {
    render() {
        return (
            <Container autocomplete="on" onSubmit={this.props.handleSubmit}>
                <MultipleGroupHalf>
                    <Field
                        name="firstName"
                        component={InputGroup}
                        type="text"
                        label="First name"
                        placeholder="First Name"
                        autocomplete="off"
                    />
                    <Field
                        name="lastName"
                        component={InputGroup}
                        type="text"
                        label="Last name"
                        placeholder="Last Name"
                        autocomplete="off"
                    />
                </MultipleGroupHalf>
                <MultipleGroupHalf>
                    <Field
                        name="address"
                        component={InputGroup}
                        type="text"
                        label="Street No & Street"
                        placeholder="Street No & Street"
                        autocomplete="off"
                    />
                </MultipleGroupHalf>
                <MultipleGroupHalf>
                    <Field
                        name="postalCode"
                        component={InputGroup}
                        type="text"
                        label="Postal code"
                        placeholder="Postal code"
                        autocomplete="off"
                        maxLength={5}
                    />
                    <Field
                        name="email"
                        component={InputGroup}
                        type="email"
                        label="Email"
                        placeholder="Email"
                        autocomplete="off"
                    />
                </MultipleGroupHalf>
                <CheckboxWrapper>
                    <GetUpdatesCheckbox />
                </CheckboxWrapper>
                <ButtonGroupWrapper
                    isFormSubmitting={this.props.isFormSubmitting}
                    rightPosition={23}
                >
                    <TwoGroup>
                        <Button label="Back" onClick={this.props.onBack} />
                        <Button
                            primary={true}
                            type="submit"
                            label="Continue"
                            className="submitButton"
                            disabled={this.props.invalid}
                            isSubmitting={this.props.isFormSubmitting}
                        />
                        <LoadingSpinner />
                    </TwoGroup>
                </ButtonGroupWrapper>
            </Container>
        );
    }
}

ElectionReminderForm.propTypes = {
    onBack: PropTypes.func,
    invalid: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func,
    isFormSubmitting: PropTypes.bool
};

export default compose(
    connect(state => ({
        initialValues: {
            getUpdates: true,
            firstName: getCachedFirstName(state),
            lastName: getCachedLastName(state),
            address: state.cachedFormData.address || '',
            postalCode: state.cachedFormData.postalCode || '',
            email: state.cachedFormData.email || ''
        }
    })),
    reduxForm({
        form: 'electionReminderForm',
        destroyOnUnmount: false,
        validate
    })
)(ElectionReminderForm);



// WEBPACK FOOTER //
// ./src/components/ElectionReminder/ElectionReminderForm.jsx